import store from "../../store";

export default {
  beforeRouteEnter(to, from, next) {
    console.log("chairman:mixin:beforeRouteEnter");
    const currentUser = store.state.auth.user;
    if (
      currentUser != null &&
      (currentUser.mansion._id != to.params.mc_code ||
        !currentUser.permissions.includes("Director"))
    ) {
      console.log(":401");
      next({
        name: "notfound404",
        params: { mc_code: currentUser.mansion._id },
      });
    } else {
      next();
    }
  },
};
